// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1q-l0","file":"styles_file__3Z2O8"};